import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// material
import { Card, Typography, Stack, Button } from '@mui/material';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

AerosMapCard.propTypes = {
  aero: PropTypes.object
};
export default function AerosMapCard({ aero }) {
  const navigate = useNavigate();
  const { nom, oaci } = aero;
  function handleAerosSelect() {
    navigate('/aeros/details', {
      state: {
        oaci: aero.oaci
      }
    });
  }

  return (
    <Card>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={0.25}
        sx={{ p: 3 }}
      >
        <Button onClick={() => handleAerosSelect()}>
          <Typography variant="h6" noWrap>
            {nom}
          </Typography>
        </Button>
        <Typography variant="body2"> {oaci}</Typography>
      </Stack>
    </Card>
  );
}
